import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashUniqBy from 'lodash/fp/uniqBy';
import SrLink from 'client/components/SrLink/SrLink';
import classnames from 'classnames';

import {
  LEAD_ACTIVITY_ASSIGNED,
} from 'common/leadConstants';

import {
  DATA_TABLE_SOURCE_RENTER_FEED,
  DATA_TABLE_VIEW_ID_RENTER_FEED_LEAD,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableLoadItems,
} from 'client/helpers/dataTables';

// TODO: Combine/share lead activity logic in SrAgentLeadListingActivity and AgentLeadActivityPages.
function getDataTableSettingsFromProps({ lead }) {
  return {
    dataSource: DATA_TABLE_SOURCE_RENTER_FEED,
    viewId: `${DATA_TABLE_VIEW_ID_RENTER_FEED_LEAD}-${lead && lead.renterUserId || ''}`,
    sort: {
      'renterActivity.createdDate': 'desc',
    },
    filter: {
      'renterActivity.renterUserId': lead ? lead.renterUserId : null,
    },
  };
}

@dataTable(getDataTableSettingsFromProps)
class SrAgentLeadListingActivity extends Component {
  static propTypes = {
    lead: PropTypes.object.isRequired,
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }

  componentDidMount() {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadItems, {
        count: 3000,
        ...getDataTableSettingsFromProps(this.props),
      });
    }
  }

  render() {
    const { lead, items } = this.props;
    const activities = items.filter((activity) => {
      return activity.activityType !== LEAD_ACTIVITY_ASSIGNED;
    });

    const listingThumbnails = lodashUniqBy('listingId', activities)
      .filter((activity) => activity.sunroomPhotoUrls && activity.hiddenPhotoUrls)
      .map((activity) => {
        return (activity.sunroomPhotoUrls.filter((url) => !activity.hiddenPhotoUrls.includes(url)))[0];
      });

    let listingThumbnailUrls;
    let numAdditionalListings;
    if (listingThumbnails && listingThumbnails.length === 6) {
      listingThumbnailUrls = listingThumbnails.slice(0, 6);
      numAdditionalListings = 0;
    }
    else {
      listingThumbnailUrls = listingThumbnails.slice(0, 5);
      numAdditionalListings = listingThumbnails.length - listingThumbnailUrls.length;
    }

    return (
      <div className='sectionsContainer listingActivity'>
        <div className='section'>
          <span className='title'>activity on listings</span>
          <div className='rowsContainer'>
            <div className='row'>
              {listingThumbnails.length > 0
                ? (
                  <div
                    className={classnames(
                      'listingActivityGrid',
                      { large: listingThumbnails.length > 3 },
                    )}
                  >
                    {listingThumbnailUrls.map((url) => (
                      <SrLink
                        to={`/agent/lead/${lead.renterUserId}/activity`}
                        key={url}
                      >
                        <div
                          style={{ backgroundImage: `url("${url}")` }}
                          className='listingActivityGridThumbnail'
                        />
                      </SrLink>
                    ))}
                    {numAdditionalListings > 1 && (
                      <SrLink
                        to={`/agent/lead/${lead.renterUserId}/activity`}
                        key='moreListingsDiv'
                      >
                        <div
                          style={{ backgroundImage: `url("${listingThumbnails[5]}")` }}
                          className='listingActivityGridThumbnail'
                        >
                          <div className='moreListingsOverlay'>+{numAdditionalListings}</div>
                        </div>
                      </SrLink>
                    )}
                  </div>
                ) : (
                  <span>
                    No listing activity yet!
                  </span>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SrAgentLeadListingActivity.displayName = 'SrAgentLeadListingActivity';

export default SrAgentLeadListingActivity;
